export const STEP_BLACK_APP_DEEPLINK =
    'step://app/waitlist?waitlist_id=STEP_BLACK'
